/**
 * Compliance / FMCSA shared types.
 *
 * Scope: ONLY the carrier-verification failure-reason discriminator. The
 * `DOTVerification` / `MCVerification` interface shapes themselves stay
 * local to backend (`compliance-integrations/interfaces/fmcsa.types.ts`)
 * and frontend (`apps/web-tms/src/types/compliance.ts`) for now — they
 * already differ on a couple of optional fields and aligning them is a
 * separate refactor. Centralizing the failure-reason literal here is the
 * actual DRY win: the value is compared in switches / equality checks
 * across both sides and would otherwise drift silently.
 */

/**
 * Reason a DOT/MC verification returned `valid: false`. `NOT_FOUND_IN_REGISTRY`
 * is the ONLY legitimate "valid: false" outcome — the FMCSA API responded
 * normally but the carrier isn't registered. Auth/network/schema failures are
 * thrown as `IntegrationException` server-side so they surface as proper 5xx
 * instead of being silently rendered to the user as "invalid number" (Rule 15).
 */
export type CarrierVerificationFailureReason = 'NOT_FOUND_IN_REGISTRY';

/** Single source of truth for the literal — prevents drift across files. */
export const NOT_FOUND_IN_REGISTRY: CarrierVerificationFailureReason = 'NOT_FOUND_IN_REGISTRY';
